import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import './Header.scss';
import { ReactComponent as ArrowRightIcon } from '../../assets/icons/arrow-right.svg';

import { useNavigate } from 'react-router';
import { resetMemberStore } from '../../store/memberSlice';

const Header: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentPage = useSelector((state: RootState) => state.page);
  const { alertsCount } = useSelector((state: RootState) => state.alerts);

  const onBackBtnClick = () => {
    dispatch(resetMemberStore());
    navigate('/members');
  };

  return (
    <div className='header' >
      {currentPage.showSidebar ? (
        <div>
          {window.location.pathname === '/alerts' && (
            <span className='test-results-header-title'>Alerts {alertsCount ? `(${alertsCount})` : ''}</span>
          )}
        </div>
      ) : (
        <div className='back-btn' onClick={onBackBtnClick}>
          <ArrowRightIcon />
          Back
        </div>
      )}
    </div>
  );
};
export default Header;
